'use client';

import React from 'react';
import styled from '@benzinga/themetron';
import { sanitizeHTML } from '@benzinga/frontend-utils';

export interface StandOutAreaProps {
  title: string;
  description: string;
}

export const StandOutArea: React.FC<StandOutAreaProps> = ({ description, title }) => {
  const createMarkup = (description: string) => {
    return { __html: sanitizeHTML(description) };
  };

  return (
    <Container className="bz3-stand-out-container">
      <span className="bz-fa-stand-out">BZ</span>
      <h3 className="stand-out-title font-bold mb-1">{title}</h3>
      <div className="stand-out-content" dangerouslySetInnerHTML={createMarkup(description)} />
    </Container>
  );
};

const Container = styled.div`
  &.bz3-stand-out-container {
    ol {
      list-style: decimal;
      margin-left: 2rem;
      li {
        margin-bottom: 0.2rem;
      }
      ul,
      ol {
        margin-bottom: 0;
      }
    }
    ul {
      list-style: disc;
      margin-left: 2rem;
      ul,
      ol {
        margin-bottom: 0;
      }
    }
    position: relative;
    padding: 15px 25px;
    margin: 15px;
    color: rgb(40, 61, 89);
    a {
      color: #2ca2d1;
      cursor: pointer;
      font-style: normal;
      &:hover {
        color: #07729c;
      }
    }
    p {
      font-style: normal;
      color: rgb(40, 61, 89);
      font-size: 17px;
      line-height: 1.4;
    }
    .stand-out-title {
      font-family: sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      margin: 0 5px 0 0;
      color: rgb(40, 61, 89);
    }
    .bz-fa-stand-out {
      position: absolute;
      left: -17px;
      font-size: 13px;
      font-weight: 700;
      font-style: normal;
      padding: 4px 10px;
      color: #75644f;
      background: #ffefd9;
      border-radius: 100%;
      height: 35px;
      line-height: 28px;
      width: 35px;
      text-align: center;
    }
    &:after,
    &:before {
      content: '';
      border-top: 2px solid #e2ebf4;
      border-bottom: 2px solid #e2ebf4;
      border-left: 2px solid #e2ebf4;
      width: 25px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    &:after {
      border-right: 2px solid #e2ebf4;
      border-left: 0;
      right: 0;
      left: auto;
    }
  }
`;
